import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10940096")

_pushScopeId("data-v-10940096")
const _hoisted_1 = { class: "register-member mt-8 ml-8 mr-8 text-gray-333 mb-40" }
const _hoisted_2 = { class: "flex items-center mb-6 font-bold text-2xl page-title" }
const _hoisted_3 = { class: "mr-8" }
const _hoisted_4 = { class: "box-register-member flex justify-between items-baseline" }
const _hoisted_5 = { class: "box-shift__tab flex flex-wrap pt-3 pb-0" }
const _hoisted_6 = { class: "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row" }
const _hoisted_7 = { class: "content-tab" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('registerMember.menu')), 1),
      _createVNode("div", null, [
        _createVNode(_component_Input, {
          class: "input-search",
          radius: "59px",
          icon: _ctx.iconSearch,
          placeholder: _ctx.t('searchByName')
        }, null, 8, ["icon", "placeholder"])
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("ul", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataTabs, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: ["text-center cursor-pointer px-5 py-3 rounded block tab-link", _ctx.currentRouter.path.includes(item.name) ? 'active' : ''],
              key: index,
              to: item.path
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(item.text), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_router_view)
    ])
  ]))
})